<template>
  <svg
    height="25"
    viewBox="0 0 124 31"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>Logo/yardi-gradient</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <linearGradient
        id="linearGradient-1"
        x1="0.865414326%"
        y1="51.1770471%"
        x2="87.3295997%"
        y2="47.6868317%"
      >
        <stop
          stop-color="#0075D3"
          offset="0%"
        ></stop>
        <stop
          stop-color="#0084F1"
          offset="100%"
        ></stop>
      </linearGradient>
      <mask id="yardi-logo-gradient">
        <path
          d="M0,30.4996491 L0,17.925614 L21.8414035,0.0870175439 L21.8414035,13.0091228 L0,30.4996491 Z M3.95929825,14.4449123 L0,12.2259649 L0,0.0870175439 L3.95929825,2.39298246 L3.95929825,14.4449123 Z M34.0238596,14.6624561 L28.8463158,0.783157895 L34.8505263,0.783157895 L37.5045614,10.0505263 L43.7263158,0.783157895 L50.7312281,0.783157895 L39.7670175,14.7059649 L37.9831579,23.1031579 L32.24,23.1031579 L34.0238596,14.6624561 Z M55.9522807,0.783157895 L61.8259649,0.783157895 L65.4807018,23.1031579 L59.6505263,23.1031579 L59.1284211,19.1003509 L51.2533333,19.1003509 L48.9908772,23.1031579 L42.8561404,23.1031579 L55.9522807,0.783157895 Z M53.4722807,14.7929825 L58.6063158,14.7929825 L57.7361404,6.78736842 L57.6926316,6.78736842 L53.4722807,14.7929825 Z M71.4849123,0.783157895 L82.4491228,0.783157895 C84.7550877,0.783157895 86.4519298,1.13122807 87.5831579,1.87087719 C88.9319298,2.7845614 89.6280702,4.35087719 89.6280702,6.52631579 C89.6280702,10.1810526 87.9312281,12.2694737 84.5375439,12.7480702 L84.5375439,12.7915789 C86.0603509,13.1831579 86.8,14.4014035 86.8,16.5333333 C86.8,17.0989474 86.8,17.8385965 86.7564912,18.7522807 C86.7129825,19.6659649 86.7129825,20.3185965 86.7129825,20.7101754 C86.7129825,21.8849123 86.8435088,22.6680702 87.0610526,23.0596491 L81.2308772,23.0596491 C81.1003509,22.4940351 81.0568421,22.0589474 81.0568421,21.7978947 C81.0568421,21.4498246 81.1003509,20.8407018 81.1438596,19.9705263 C81.1873684,19.1438596 81.2308772,18.4477193 81.2308772,17.8821053 C81.2308772,15.8807018 80.2736842,14.88 78.3592982,14.88 L74.4870175,14.88 L72.6596491,23.1031579 L66.8294737,23.1031579 L71.4849123,0.783157895 Z M75.2701754,10.6596491 L79.8821053,10.6596491 C82.4926316,10.6596491 83.7978947,9.6154386 83.7978947,7.57052632 C83.7978947,6.00421053 82.7536842,5.2645614 80.6652632,5.2645614 L76.4014035,5.2645614 L75.2701754,10.6596491 Z M94.4140351,0.783157895 L102.767719,0.783157895 C109.381053,0.783157895 112.731228,3.91578947 112.731228,10.2245614 C112.731228,13.922807 111.687018,16.9249123 109.555088,19.274386 C107.205614,21.8414035 103.898947,23.1031579 99.6785965,23.1031579 L89.6715789,23.1031579 L94.4140351,0.783157895 Z M96.5894737,18.0996491 L100.418246,18.0996491 C102.680702,18.0996491 104.377544,17.2294737 105.552281,15.4891228 C106.465965,14.1403509 106.901053,12.5305263 106.901053,10.7031579 C106.901053,7.39649123 105.421754,5.74315789 102.506667,5.74315789 L99.1564912,5.74315789 L96.5894737,18.0996491 Z M118.082807,0.783157895 L123.912982,0.783157895 L119.257544,23.1031579 L113.38386,23.1031579 L118.082807,0.783157895 Z"
          fill="white"
        ></path>
      </mask>
    </defs>
    <g mask="url(#yardi-logo-gradient)">
      <rect
        x="0"
        y="0"
        width="124"
        height="31"
        fill="white"
      />
      <rect
        id="logo-gradient"
        x="0"
        y="0"
        width="124"
        height="31"
        fill="url(#linearGradient-1)"
        class="uk-preserve"
      />
    </g>
  </svg>
</template>
